import { Alert, AlertDescription } from "@bcc/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { setImportErrorAlertMessageTestId, setImportErrorAlertTestId } from "./import-error-alert.utils";

interface ImportErrorAlertProps {
  error: string | null;
  testId?: string;
  className?: string;
}

export function ImportErrorAlert({ error, testId, className }: ImportErrorAlertProps) {
  if (!error) {
    return null;
  }

  return (
    <Alert variant="destructive" data-testid={testId ?? setImportErrorAlertTestId("default")} className={className}>
      <AlertCircle className="h-4 w-4" />
      <AlertDescription data-testid={setImportErrorAlertMessageTestId("default")}>{error}</AlertDescription>
    </Alert>
  );
}
